import { ariaGetControlledElement, ariaSet } from '@vo/js/utils/aria'

export default (function () {
    const links = document.querySelectorAll('[data-subnav-link]')

    if (!links.length) return

    const contentElements = document.querySelectorAll('[data-subnav-content]')

    links.forEach((link) => {
        link.addEventListener('mouseenter', () => {
            const target = ariaGetControlledElement(link)

            if (!target) return

            contentElements.forEach(el => ariaSet('expanded', el, 'false'))
            ariaSet('expanded', target, 'true')
        })
    })
})
